import React from "react";
import { useOverrideGroupedFolderSyncMutation } from "../mutations.hotchoc.generated";
import { useSnackBar } from "~/components/snackbar";
import { useProjectFoldersPageApi } from "../ProjectFoldersPageApi";
import { OverrideSyncButtons } from "../components/OverrideSyncButtons";
import { GroupedFolder } from "../types";
import { handleResult } from "../utils";

type OverrideGroupedFolderSyncProps = {
  folder: GroupedFolder;
};

export const OverrideGroupedFolderSync: React.FC<
  OverrideGroupedFolderSyncProps
> = ({ folder }) => {
  const addAlert = useSnackBar();
  const { reload } = useProjectFoldersPageApi();
  const [handleOverride, { loading }] = useOverrideGroupedFolderSyncMutation();

  const handle = async (retry: boolean) => {
    const variables = {
      input: {
        name: folder.name,
        groupedFolderId: folder.id,
        retrySync: retry,
      },
    };

    const response = await handleOverride({ variables });

    const errors = handleResult(
      response.data!.projectFolders!.overrideGroupedFolderSync
    );

    if (errors) {
      addAlert({
        key: `failed-sync-folder-${folder.__typename}-${folder.fullPath}`,
        message: errors,
        isSuccess: false,
      });
    } else {
      addAlert({
        key: `sync-folder-${folder.__typename}-${folder.fullPath}`,
        message: `"${folder.name}" ${
          retry ? "queued for sync retry" : "sync status overridden"
        }`,
        isSuccess: true,
      });

      reload();
    }
  };

  return <OverrideSyncButtons loading={loading} handle={handle} />;
};
